import React from 'react';
import {Col, Row, Container} from 'reactstrap';

const join = (props) => {

    return (
        <Container>
            <Row>
                <Col xs="12" sm="12" md="12" >
                    <div className="join">
                        <div className="title">
                            <h2>מה נשמע?</h2>
                            <p>הצטרפו והשמיעו לחברים את השירים שאתם אוהבים</p>
                        </div>
                        <div className="content">
                            {props.children} 
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default join;
